import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import PortalIdParser from 'PortalIdParser';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { getWhatsAppWorkflowUsagesRpc } from '../../../../../__generated__/chirp/com/hubspot/content/whatsapp/rpc/WhatsAppWorkflowsUsagesRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export async function fetchWhatsAppWorkflowUsages(whatsAppId) {
  const result = await rpcClient.callWithResultUnion(getWhatsAppWorkflowUsagesRpc, {
    request: {
      whatsAppId
    }
  });
  if (result.type === 'rpcError') {
    throw result.rpcError;
  }

  // @ts-expect-error: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/chirp-FE-one-page.html#type-safe-error-handling
  if (result.type === 'internalError') {
    // @ts-expect-error: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/chirp-FE-one-page.html#type-safe-error-handling
    throw result.internalError;
  }
  const usages = result.data.usages || [];
  return {
    '@ok': usages.map(usage => {
      return {
        portalId: PortalIdParser.get(),
        objectTypeId: OBJECT_TYPE.WORKFLOW,
        objectId: usage.workflowCrmObjectId,
        properties: {
          hs_flow_id: {
            value: usage.flowId.toString()
          },
          hs_name: {
            value: usage.workflowName
          },
          hs_enabled: {
            value: usage.enabled.toString()
          },
          hs_source_app: {
            value: usage.sourceApp
          }
        }
      };
    }) || []
  };
}